import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EventPublicCard from "./event-public-card";
import Api from "../../../services/api.service";

export default function EventsGrid() {
    const { i18n } = useTranslation();
    const lang = (i18n.language?.slice(0, 2) || 'fr');

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const json = await Api.getPublicEvents();
            console.log(json);

            setItems(json?.data?.data || []);
            setLoading(false);
        })();
    }, []);

    if (loading) {
        return (
            <div className="py-12 px-4 sm:px-8 md:px-24">
                <div className="h-6 w-56 bg-gray-200 animate-pulse rounded mb-6" />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="h-80 bg-white border border-gray-200 rounded-xl shadow animate-pulse" />
                    ))}
                </div>
            </div>
        );
    }

    if (!items.length) return null;

    return (
        <section className="py-12 px-4 sm:px-8 md:px-24">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 auto-rows-fr">
                {items.map(ev => (
                    <EventPublicCard key={ev._id} ev={ev} lang={lang} />
                ))}
            </div>
        </section>
    );
}